import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export default function PulsePage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">创始人脉搏</h1>
        <p className="mt-1 text-sm text-muted-foreground">今日主线、番茄钟、状态和本周待办</p>
      </div>
      <Card>
        <CardHeader>
          <CardTitle>番茄钟</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">功能和图表即将实现。</p>
        </CardContent>
      </Card>
    </div>
  );
}